import styled from "styled-components";
import { ColorPaletteRoleBackgroundOptions } from "../../../types/theming";

import { DividerProps, DividerSizes } from "./Divider.types";

const getGapSize = (size?: keyof DividerSizes) => {
	switch (size) {
		case "lg":
			return 12;
		case "md":
			return 6;
		case "sm":
		default: {
			return 4;
		}
	}
};

const getColorToken = (colorOn?: ColorPaletteRoleBackgroundOptions) => {
	return colorOn === "bg_dark" || colorOn === "bg_dark_variant"
		? "fg_dark_3"
		: "fg_light_3";
};

const StyledDivider = styled.hr<DividerProps>`
	flex: 1;
	box-sizing: border-box;
	border: none;
	background: ${({ colorOn, size, theme, variant }) => {
		const gap = getGapSize(size);
		const color = theme.palette.hexFor(getColorToken(colorOn));
		return variant === "dashed"
			? `radial-gradient(circle closest-side,${color} 100%,#0000) 0 0/${gap}px 100%,
      linear-gradient(90deg,${color} 50%, #0000 0) calc(${gap}px/2) 0/calc(2*${gap}px) 100%;`
			: color;
	}};
	background-position-x: ${({ size }) => {
		const gap = getGapSize(size);
		return `-${gap}px, -${gap / 2}px`;
	}};

	${({ size }) => {
		switch (size) {
			case "lg":
				return {
					height: "4px",
					marginTop: 0,
				};
			case "md":
				return {
					height: "2px",
					marginTop: "2px",
				};
			case "sm":
			default: {
				return {
					height: "1px",
					marginTop: "3px",
				};
			}
		}
	}};
	border-radius: ${({ size }) => (size === "lg" ? "4px" : "2px")};
`;

export const StyledDividerWrapper = styled.div<DividerProps>`
	display: flex;
`;

export default StyledDivider;
